import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    :root {
        --maxWidth: 1280px;
        --white: #fff;
        /* --lightGray: #eee;
        --medGray: #353535;
        --darkGray: #1c1c1c; */
        --lightGray: #eee;
        --medGray: #3F3351;
        --darkGray: #1F1D36;  
        --fontSuperBig: 2.5rem;
        --fontBig: 1.5rem;
        --fontMed: 1.2rem;
        --fontSmall: 1rem;
    }
    * {
    box-sizing: borderbox;
    font-family: "Abel", sans-serif;
    }
    body{
        margin: 0;
        padding: 0;
        h1{
            font-size: 2rem;
            font-weight: 600;
            color: var(--white);
        }
        h3{
            font-size: 1.1rem;
            font-weight: 500;
        }
        p{
            font-size: 1rem;
            color: white;
        }
    }
`;

